export const onlyAllowPositiveDecimal = event => {
  const char = String.fromCharCode(event.which)

  // Allow digits and dot only
  const isValid = /^[0-9.]$/.test(char)
  const inputValue = event.target.value

  // Prevent more than one dot
  const hasDotAlready = inputValue.includes('.') && char === '.'

  if (!isValid || hasDotAlready) {
    event.preventDefault()
  }
}
export const blockInvalidPaste = event => {
  const paste = (event.clipboardData || window.clipboardData).getData('text')

  // Block if paste contains anything other than a valid positive decimal
  if (!/^(?:0|[1-9]\d*)(\.\d+)?$/.test(paste.trim())) {
    event.preventDefault()
  }
}
export const blockInvalidIntegerPaste = event => {
  const paste = (event.clipboardData || window.clipboardData).getData('text')

  // Allow only non-empty strings of digits (no decimals, no negatives)
  if (!/^[1-9]\d*$/.test(paste.trim())) {
    event.preventDefault()
  }
}
export const onlyAllowPositiveInteger = event => {
  const char = String.fromCharCode(event.which)

  // Allow digits 0–9 only
  const isValid = /^[0-9]$/.test(char)

  if (!isValid) {
    event.preventDefault()
  }
}
